define('app-Agents/modules/header/settings',[],function () {
    return {
        container: "#agentHeader",
        information: {
            container: ".agentInformationContainer",
            text: ".agentInformationMessage"
        }
    };
});
